export const formatActivitiesPlaces = (activities) => {
  const result = [];
  for (let i = 0; i < activities.length / 2; i++) {
    result.push(activities[i]);
    result.push(activities[i + Math.ceil(activities.length / 2)]);
  }
  return result;
};
